import React from 'react';
import { updateTabTitle } from '../../../utils/tabTitle';


function OrganizationDropdown({
  user,
  navigate,
  onClose,
  submenuItemStyles,
  selectedOrgId
}) {

  const handleOrgDashboardClick = () => {
    if (selectedOrgId) {
      updateTabTitle(selectedOrgId);
    }
    navigate(`/org-dashboard/${selectedOrgId}`);
    onClose();
  };

  const handleTeamsClick = () => {
    if (selectedOrgId) {
      updateTabTitle(selectedOrgId);
    }
    navigate(`/organization-management/${selectedOrgId}`);
    onClose();
  };

  const handleMembersClick = () => {
    if (selectedOrgId) {
      updateTabTitle(selectedOrgId);
    }
    navigate(`/organization-members/${selectedOrgId}`);
    onClose();
  };

  const handleOrgLeadsClick = () => {
    if (selectedOrgId) {
      updateTabTitle(selectedOrgId);
    }
    navigate(`/organization-leads/${selectedOrgId}`);
    onClose();
  };

  const handleAgenturenClick = () => {
    if (selectedOrgId) {
      updateTabTitle(selectedOrgId);
    }
    // Navigiere zur Agenturen-Seite mit der ausgewählten Organisation
    navigate(`/agenturen?orgId=${selectedOrgId}`);
    onClose();
  };

  const menuItemStyle = {
    ...submenuItemStyles,
    justifyContent: 'flex-start'
  };

  const dashboardItemStyle = {
    ...menuItemStyle,
    fontWeight: '600'
  };

  const separatorStyle = {
    height: '1px',
    backgroundColor: '#e2e8f0',
    margin: '4px 0'
  };

  return (
    <>
      {/* Organisations Dashboard - Hervorgehoben */}
      <button 
        style={dashboardItemStyle}
        onClick={handleOrgDashboardClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        📊 Organisations Dashboard
      </button>

      {/* Trennlinie */}
      <div style={separatorStyle}></div>

      {/* Meine Teams */}
      <button 
        style={menuItemStyle}
        onClick={handleTeamsClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        👨‍👩‍👧‍👦 Meine Projekte
      </button>
      
      {/* Meine Agenturen */}
      <button 
        style={menuItemStyle}
        onClick={handleAgenturenClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        🤖 Meine Agenturen
      </button>

      {/* Mitglieder verwalten */}
      <button 
        style={menuItemStyle}
        onClick={handleMembersClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        👤 Mitglieder verwalten
      </button>
      
      {/* Alle Organisations-Leads */}
      <button 
        style={menuItemStyle}
        onClick={handleOrgLeadsClick}
        onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
        onMouseLeave={(e) => e.target.style.background = 'transparent'}
      >
        📋 Alle Organisations-Leads
      </button>
    </>
  );
}

export default OrganizationDropdown;